module.exports = __webpack_public_path__ + "media/src/images/logos/icon_dark_bg-cfc13c9ba5f4ad685d7a47f417cddc86.png";